





























import { Component, Vue } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import Positions from '@/components/Positions/Positions.vue'
import Alert from '@/components/Shared/Alert.vue'
import GiganautVue from '@/components/Shared/GiganautVue'
import PageNames from '@/router/PageNames';


@Component({
	name: 'AgencyPositionSettings',
  	components: { Positions, Alert }
})
export default class extends GiganautVue {

	beforeMount() {
		AgencySettingsModule.getPositions();
		AgencySettingsModule.getSkills();
		AgencySettingsModule.getQualifications();
		AgencySettingsModule.getIndustries();
		AgencySettingsModule.getUniforms();
  	}

	navigateToAgencySettings() {
		this.$router.push({ name: PageNames.AgencySettings });
	}

  	get loading() {
		return AgencySettingsModule.loadingPositions;
  	}
}
